































import Vue from 'vue'
import ExmasForTensakuVisiter from '../../utils/ExmasForTensakuVisiter'

type DataType = {
  width: number | null
}

export default Vue.extend({
  data(): DataType {
    return {
      width: null,
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  computed: {
    rootPath(): string {
      return process.env.VUE_APP_ROOT_PATH || ''
    },
    newRootPath(): string {
      return process.env.VUE_APP_NEW_ROOT_PATH || ''
    },
    displayForMember(): boolean {
      return this.$store.state.isMemberPage
    },
    // mailtoに改行を入れた場合にうまくメーラで表示できる環境かどうか。
    // 厳密は判別は不可能なのでアドホックな対応
    isMultilineMailEnv(): boolean {
      const ua = window.navigator.userAgent.toLowerCase()
      // windowsのメーラはおそらく複数行対応
      if (ua.includes('windows')) {
        return true
      }

      // それ以外の場合、PCのメーラは複数行表示可能で、モバイル端末のメーラは不可能な場合が多い
      // 特にiphoneは改行が <BR> と表示されて格好悪い

      // タッチ可能ならモバイル端末扱いにする
      if ('ontouchend' in document) {
        return false
      }
      // 画面幅が狭い場合はスマホ扱いにする
      if (this.width && this.width <= 768) {
        return false
      }
      return true
    },
    visiterMailBody(): string {
      if (!this.isMultilineMailEnv) {
        // モバイルデバイスの場合は改行のない本文を使う
        return "1.お子様のお名前、2.お電話番号、3.お問い合わせ内容をご記載ください。"
      } else {
        // PCの場合は改行のある本文
        return "■お子様のお名前%0D%0A%0D%0A■お電話番号%0D%0A%0D%0A■お問い合わせ内容%0D%0A"
      }
    },
    visiterMailto(): string {
      let info = this.$store.state?.examInfo
      if (!info) {
        const examKey = this.$route.params['exam_id']
        if (examKey && Object.keys(ExmasForTensakuVisiter).includes(examKey)) {
          info = ExmasForTensakuVisiter[examKey]
        }
      }
      if (!info) return `mailto:cs@conan-zemi.com?subject=【小学一年生小学館思考力テスト】お問い合わせ&body=${this.visiterMailBody}`
      if (info.type === 'MAGAZINE') return `mailto:cs@conan-zemi.com?subject=【小学一年生小学館思考力テスト】お問い合わせ&body=${this.visiterMailBody}`
      return `mailto:cs@conan-zemi.com?subject=【体験版  小学館思考力テスト】お問い合わせ&body=${this.visiterMailBody}`
    },
    // フッターのクレジット文言取得
    getCreditMessage(): string {
      let credit_message = '©青山剛昌／小学館 ©青山剛昌／小学館・読売テレビ・TMS 1996'
      const switch_date = new Date('2024-12-01T17:00:00+0900')
      // 2024/12/01より前は下記のクレジット文言
      if(switch_date > new Date()) {
        credit_message = '©青山剛昌／小学館 ©青山剛昌／小学館・読売テレビ・TMS 1996 ©名探偵コナンゼミLLP'
      }
      return credit_message
    },
  },
  methods: {
    handleResize(): void {
      this.width = window.innerWidth;
    },
    moveVisiterFaq(): void {
      let info = this.$store.state?.examInfo
      if (!info) {
        const examKey = this.$route.params['exam_id']
        if (examKey && Object.keys(ExmasForTensakuVisiter).includes(examKey)) {
          info = ExmasForTensakuVisiter[examKey]
        }
      }
      if (!info) this.$router.push(`/tensaku_visiter/faq/`)
      let routeData = this.$router.resolve({name: 'FAQ', params: { exam_id: info.examGroupKey }});
      window.open(routeData.href, '_blank');
    }
  }
})
